import { applyMiddleware, combineReducers, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import chatSliceReducer from "src/store/slices/chatSlice";
import onboardingSlice from "./slices/onboardingSlice";
import AuthenticationSlice from "./slices/AuthenticationSlice";
import ThreadsSlice from "src/store/slices/threadsSlice";
import messageSlice from "src/store/slices/messageSlice";
import homeSlice from "src/store/slices/HomeSlice";
import modalSlice from "./slices/modalSlice";
import versionSlice from "./slices/versionSlice";
import profileMemorySlice from "./slices/profileMemorySlice";
import checkoutFlowSlice from "./slices/checkoutFlowSlice";
import emailContextSlice from "src/store/slices/emailContextSlice";
import sharedThreadSlice from "./slices/sharedThreadSlice";

const allReducers = combineReducers({
  chat: chatSliceReducer,
  onboarding: onboardingSlice,
  auth: AuthenticationSlice,
  threads: ThreadsSlice,
  modalSlice: modalSlice,
  messageSlice: messageSlice,
  homeslice: homeSlice,
  version: versionSlice,
  profileMemory: profileMemorySlice,
  checkoutFlow: checkoutFlowSlice,
  emailContext: emailContextSlice,
  sharedSlice: sharedThreadSlice,
});

const applicationStore = createStore(allReducers, applyMiddleware(thunkMiddleware));

export type RootState = ReturnType<typeof applicationStore.getState>;
export type AppDispatch = typeof applicationStore.dispatch;

// Wire the apiClient 402-interceptor to this store so it can dispatch
// openWithEntry on backend-driven gating events. Registered eagerly here so
// it's live before any thunk fires; see src/services/apiClient.ts.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { registerApiClientStore } = require("src/services/apiClient");
registerApiClientStore(applicationStore);

export default applicationStore;
